import { inputAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    parts.keys,
)

// base
const baseStyle = definePartsStyle(({ theme }) => {
    const colors = theme.colors

    return {
        field: {
            _placeholder: { color: colors.captions.placeholder },
            color: colors.green.default,
        },
    }
})

// sizes
const size = {
    md: defineStyle({
        px: '18px',
        py: '11px',
        height: '42px',
        fontSize: '0.75rem',
        lineHeight: '1.25rem',
        _placeholder: {
            fontSize: '0.75rem',
            lineHeight: '1.25rem',
        },
    }),
    sm: defineStyle({
        px: '15px',
        py: '8px',
        height: '33px',
        fontSize: '0.6875rem',
        lineHeight: '1.0625rem',
        borderRadius: '8px',
        _placeholder: {
            fontSize: '0.6875rem',
            lineHeight: '1.0625rem',
        },
    }),
}

const sizes = {
    md: definePartsStyle({
        field: size.md,
        addon: size.md,
    }),
    sm: definePartsStyle({
        field: size.sm,
        addon: size.sm,
    }),
}

// variants
const variants = {
    filled: definePartsStyle(({ theme }) => {
        const colors = theme.colors

        return {
            field: {
                border: '1px solid',
                borderRadius: '8px',
                borderColor: colors.bg['green10'],
                backgroundColor: colors.beige.highlighted,
                _hover: {
                    borderColor: colors.captions.disabled,
                    backgroundColor: colors.beige.highlighted,
                },
                _focusVisible: {
                    borderColor: colors.green.default,
                    backgroundColor: colors.beige.highlighted,
                },
                _active: {
                    borderColor: colors.green.default,
                },
                _readOnly: {
                    pointerEvents: 'none',
                    borderColor: colors.green.transparent_10,
                    backgroundColor: colors.beige.darkened_2,
                },
                _disabled: {
                    cursor: 'not-allowed',
                },
                _invalid: {
                    borderColor: colors.orange['100'],
                },
            },
            addon: {
                backgroundColor: colors.beige.highlighted,
            },
        }
    }),
}

//
export const Input = defineMultiStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        size: 'sm',
        variant: 'filled',
    },
})
